import React from 'react';
import ReactDOM from 'react-dom';
import App from '.';

ReactDOM.render(<App />, document.getElementById('head'));



// WEBPACK FOOTER //
// ./frontend/react/apps/head/entry.js